import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload LCP hero image and warm up the CDN connection BEFORE React
// even starts rendering. This runs synchronously in the entry bundle so
// the browser begins fetching the image alongside parsing the JS.
if (typeof document !== 'undefined') {
  const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/6TLc9KtkH5TMhVgWdeFj3t/Diseno_sin_titulo_%284%29.webp';
  // Preconnect to image CDN first so the TCP/TLS handshake happens in parallel
  if (!document.querySelector('link[rel="preconnect"][href="https://cdn.magicpatterns.com"]')) {
    const pc = document.createElement('link');
    pc.rel = 'preconnect';
    pc.href = 'https://cdn.magicpatterns.com';
    document.head.insertBefore(pc, document.head.firstChild);
  }
  if (!document.querySelector(`link[rel="preload"][href="${HERO_IMAGE}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = HERO_IMAGE;
    (preload as any).fetchPriority = 'high';
    document.head.insertBefore(preload, document.head.firstChild);
  }
}
render(<App data-id="element-516" />, document.getElementById('root'));